import React, { createContext, useContext, useState, useEffect } from 'react';
import { getMe } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedFactory, setSelectedFactory] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      getMe()
        .then(res => {
          setUser(res.data);
          const saved = localStorage.getItem('selectedFactory');
          if (saved) {
            const f = res.data.factories?.find(f => f.id === parseInt(saved));
            setSelectedFactory(f || res.data.factories?.[0] || null);
          } else {
            setSelectedFactory(res.data.factories?.[0] || null);
          }
        })
        .catch(() => {
          localStorage.removeItem('token');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const loginUser = (token, userData) => {
    localStorage.setItem('token', token);
    setUser(userData);
    const factory = userData.factories?.[0] || null;
    setSelectedFactory(factory);
    if (factory) localStorage.setItem('selectedFactory', factory.id);
  };

  const logoutUser = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('selectedFactory');
    setUser(null);
    setSelectedFactory(null);
  };

  const changeFactory = (factory) => {
    setSelectedFactory(factory);
    localStorage.setItem('selectedFactory', factory.id);
  };

  return (
    <AuthContext.Provider value={{ user, loading, selectedFactory, loginUser, logoutUser, changeFactory }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
